import React from 'react'
import * as msgs from "../../constants/textConstants";
import ResourceSubTile from './ResourceSubTile'

const LyraTile = ({ lyraUrl }) => {
    return (
        <ResourceSubTile
            className="lyra-tile"
            heading={msgs.LyraTileName}
            disabled={false}
            linkHeading={true}
            newFeature
            url={lyraUrl}
            target="_blank"
            description="Mental health support for BSW employees."
        />
    )
}

export default LyraTile